/**
 * Extracts initials from a name string.
 * Takes the first letter of each word, converts to uppercase, and limits to 2 characters.
 *
 * @param name - The name to extract initials from
 * @returns The initials (max 2 characters, uppercase)
 *
 * @example
 * getInitials('John Doe') // 'JD'
 * getInitials('Alice Bob Charlie') // 'AB'
 * getInitials('Single') // 'S'
 */
export const getInitials = (name: string): string => {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}
